<template>
  <div v-loading="loading" style="height: 250px;width: 100%;" />
</template>

<script>
import { homeCurrentApi } from '@/api/ei/eiApi'
import { debounce } from '@/utils/common'

export default {
  name: 'IncomePie',

  data() {
    return {
      loading: false,
      stats: {},
      chart: null,
      chartOption: {
        title: {
          text: '本月收入分布'
        },
        legend: {
          orient: 'vertical',
          top: 40,
          right: 10,
          data: [
            '正常缴费', '逾期未缴', '预估收入'
          ]
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} :<br/> ￥{c} ({d}%)'
        },
        series: [
          {
            name: '方案收入分布',
            type: 'pie',
            label: {
              show: true,
              position: 'inside',
              formatter: '￥{c}'
            },
            radius: [0, 90],
            center: ['50%', '50%'],
            data: [
              {
                value: 0,
                name: '正常缴费',
                itemStyle: {
                  color: '#409eff'
                }
              }, {
                value: 0,
                name: '逾期未缴',
                itemStyle: {
                  color: '#e64340'
                }
              }, {
                value: 0,
                name: '预估收入',
                itemStyle: {
                  color: '#07c160'
                }
              }
            ]
          }
        ]
      }
    }
  },

  mounted() {
    this.initChart()
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize()
      }
    }, 100)
    window.addEventListener('resize', this.__resizeHandler)
  },
  created: function() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.loading = true
      homeCurrentApi().then(res => {
        this.loading = false
        if (res.errno === 0) {
          this.stats = Object.assign({}, res.data.current_income)
          this.setChart()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    setChart() {
      this.chartOption.series[0].data[0].value = this.stats.received
      this.chartOption.series[0].data[1].value = this.stats.expired
      this.chartOption.series[0].data[2].value = this.stats.due_in
      this.chart.setOption(this.chartOption)
    },

    initChart() {
      this.chart = this.$echarts.init(this.$el, 'teenager')
      this.chart.setOption(this.chartOption)
    }
  }
}
</script>
